/**
 * StreamWorks local Vidstack bundle entry.
 *
 * Output:
 *   dist/streamworks-vidstack-local.js
 *   dist/streamworks-vidstack-local.css
 *
 * WordPress/S3 usage:
 *   <link rel="stylesheet" href="/path/to/streamworks-vidstack-local.css">
 *   <script type="module" src="/path/to/streamworks-vidstack-local.js"></script>
 *
 * Then:
 *   const player = await window.StreamWorksVidstack.create({
 *     target: '#target',
 *     title: 'Example',
 *     src: 'https://example.com/master.m3u8',
 *     poster: 'https://example.com/poster.jpg',
 *     streamType: 'on-demand',
 *     thumbnails: 'https://example.com/thumbnails.vtt',
 *     tracks: [{ src: 'https://example.com/chapters.vtt', kind: 'chapters', label: 'Chapters' }]
 *   });
 */

import "vidstack/player/styles/default/theme.css";
import "vidstack/player/styles/default/layouts/video.css";

import Hls from "hls.js";
import {
  VidstackPlayer,
  VidstackPlayerLayout
} from "vidstack/global/player";

// Expose hls.js for debugging and for any Vidstack/HLS fallback code that checks window.Hls.
window.Hls = window.Hls || Hls;

function normaliseTracks(input = {}) {
  const tracks = Array.isArray(input.tracks) ? [...input.tracks] : [];

  if (input.track) {
    tracks.push({
      src: input.track,
      kind: "chapters",
      label: "Chapters",
      language: "en-US",
      default: false
    });
  }

  return tracks;
}

function normaliseStreamType(value = "") {
  const streamType = String(value || "").toLowerCase();

  if (streamType === "live" || streamType === "live:dvr" || streamType === "on-demand") {
    return streamType;
  }

  return "on-demand";
}

async function createStreamWorksVidstackPlayer(config = {}) {
  const {
    target = "#target",
    title = "StreamWorks Video",
    src,
    poster = "",
    thumbnails = "",
    crossOrigin = "anonymous",
  } = config;

  if (!src) {
    throw new Error("StreamWorksVidstack.create requires a src value.");
  }

  const tracks = normaliseTracks(config);

  return VidstackPlayer.create({
    target,
    title,
    src,
    poster,
    crossOrigin,
    streamType: normaliseStreamType(config.streamType),
    playsInline: true,
    viewType: "video",
    layout: new VidstackPlayerLayout({
      thumbnails: thumbnails || config.thumbnailTrack || "",
    }),
    tracks,
  });
}

const api = {
  VidstackPlayer,
  VidstackPlayerLayout,
  Hls,
  create: createStreamWorksVidstackPlayer,
};

window.StreamWorksVidstack = api;

export {
  VidstackPlayer,
  VidstackPlayerLayout,
  Hls,
  createStreamWorksVidstackPlayer
};
